import { CDBCard, CDBCardBody, CDBContainer, CDBDataTable } from 'cdbreact';
import React, { Component } from 'react'
import Menucustom from '../../../common/menu/menucustom';
import { Button } from 'react-bootstrap';
import RicercaRapidaService from './ricercaRapidaService';
import { toast } from 'react-toastify';
import LoadSpinner from '../../../common/spinner/loadSpinner';
import { withRouter } from 'react-router-dom';

 class RicercaRapida extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            datiRicerca:[],
            loadingtable:false,
            textRicerca:""
        }
        this.ricercaRapidaService = new RicercaRapidaService()
    }
    
    componentDidMount(){
        let ultimaRicerca = sessionStorage.getItem("ultimaRicerca");

        if(ultimaRicerca){
            this.ricerca(ultimaRicerca)
            this.setState({textRicerca:ultimaRicerca})
        }

    }


    inputHandler(event){
        const {value} = event.target

        this.setState({textRicerca:value})
    }

    navigateHanlder(type,id){
            
        if(type === "sanz"){
            sessionStorage.removeItem("rowSanzione");
            sessionStorage.setItem("rowSanzione",JSON.stringify({id:id,statoSanzione:"RicercaRapida"}));
            sessionStorage.setItem("ultimaRicerca",this.state.textRicerca)
            this.props.history.push("/detailSanzione");
            
        }
        if(type === "ing"){
            sessionStorage.removeItem("rowIngiunzione");
            sessionStorage.setItem("rowIngiunzione",JSON.stringify({id:id,statoSanzione:"RicercaRapida"}));
            sessionStorage.setItem("ultimaRicerca",this.state.textRicerca)
            this.props.history.push("/Ingiunzione");

        }
    }



    handlerTable(){
        let table = {
             columns:[
                { label: "Num. Recupero Crediti", field: "numRec", width: 270 },
                { label: "Num. Ingiunzione", field: "numIng", width: 270 },
                {
                  label: "Num. Sanzione",
                  field: "numSanz",
                  width: 100,
                  attributes: {
                    "aria-controls": "DataTable",
                    "aria-label": "Name",
                  },
                },
            ],
            rows:[]
        }


        this.state.datiRicerca.forEach((risultato,index)=>{
            let row = {
                idSanz:risultato.idSanz,
                idIng:risultato.idIng,
                numSanz:(
                    <>
                        <button 
                            className='btn btn-link'
                            key={index+12}
                            onClick={()=>this.navigateHanlder("sanz",risultato.idSanz)
                            }>{risultato.numSanz}
                        </button>
                    </>
                ),
                numIng:(
                    <>
                        <button 
                            className='btn btn-link'
                            key={`a${index+12}`}
                            onClick={()=>this.navigateHanlder("ing",risultato.numIng)
                            }>{risultato.numIng}
                        </button>
                    </>
                ),
                numRec:risultato.numRec
            }
            table.rows.push(row)
        })

        return table
    }

    ricerca(testo){
        if(testo){
            this.setState({loadingtable:true})
            this.ricercaRapidaService.find(
                testo,
                (result)=>{
                    this.setState({datiRicerca:[...result.ricercaRapidaResponse]})
                    this.setState({loadingtable:false})
                },
                ()=>{
                    toast.error("Errore Ricerca, Riprova piu tardi")
                    this.setState({loadingtable:false})
                })
        }else{
            if(this.state.textRicerca.length > 3){
            this.setState({loadingtable:true})
            this.ricercaRapidaService.find(
                this.state.textRicerca,
                (result)=>{
                    this.setState({datiRicerca:[...result.ricercaRapidaResponse]})
                    this.setState({loadingtable:false})
                },
                ()=>{
                    toast.error("Errore Ricerca, Riprova piu tardi")
                    this.setState({loadingtable:false})
                })
            }else{
                toast.error("Inserisci almeno 4 caratteri")
            }
        }
    }


  render() {
    return (
      <div id="wrapper">
        <Menucustom/>
        <div className='container-fluid'>
            <h1 className='p-4 h1 mb-2 text-gray-800'>Ricerca Rapida</h1>
            <CDBContainer>
                <CDBCard border>
                    <div className='container'>
                        <div className='row d-flex justify-align-align-content-center'>
                            <div className='col-3 p-3 d-flex justify-content-center align-items-center'>
                                <h4>Barra di ricerca</h4>
                            </div>
                            <div className='col-6 p-3'>
                                <input className='form-control' type='text' value={this.state.textRicerca} onChange={(event)=>this.inputHandler(event)}></input>
                            </div>
                            <div className='p-3 col-3'>
                                <Button
                                    className="btn btn-warning"
                                    onClick={()=>this.ricerca()}>
                                        CERCA

                                </Button>
                            </div>
                        </div>

                    </div>
                  </CDBCard>
                  <CDBCard border>  
                <CDBCardBody>
                    {this.state.loadingtable 
                    ? <LoadSpinner/>
                    :<CDBDataTable
                        sortable={false}
                        responsiveSm={true}
                        responsiveMd={true}
                        responsiveLg={true}
                        pagesAmount={3}
                        entriesLabel={""}
                        infoLabel={["Mostra da", "a", "di", "risultati trovati"]}
                        paginationLabel={["<-", "->"]}
                        striped
                        bordered
                        hover
                        checkbox
                        searching={false}
                        data={this.handlerTable()}
                        materialSearch
                    />
                    }
                </CDBCardBody>
                </CDBCard>
            </CDBContainer>
        </div>
      </div>
    )
  }
}

export default withRouter(RicercaRapida)
